/**
 * A REDIRECT THAT KEEPS THE VISITOR'S LIGHT (D-92 part 6, Miles 2026-10-24: "no matter what the process/transition …
 * and not matter what mode the user is in").
 *
 * React Router's <Navigate> draws nothing and moves only after its own commit. Where it is a route's whole element (an
 * old address: /dashboard, /blog/*, /privacy …), nothing says a light while it moves, so the document's ground falls to
 * noon: on a full load at dusk the boot splash can fade out over it (recorded on prest0.ai: 7 of 16 full loads of
 * /dashboard, brightening to as much as 198 of 255 before /wallet's sign-in check said dusk). This says the visitor's
 * light on <html> while it moves (their choice in this browser, else their device's: the light the boot splash is drawn
 * in and the next page's door opens in) and lets go in the commit the next route says its own, as the guards' screens
 * and the doors do.
 *
 * App.tsx imports it as `Navigate`, so its route lines read as they always have (the coverage gate and the public
 * machine files read them by that name). A guard that redirects also keeps its own waiting screen up beside it.
 */
import React from 'react';
import { Navigate as RouterNavigate, type NavigateProps } from 'react-router-dom';
import { PageLight } from '../../design/PageLight';
import { useWaitingLight } from '../../design/pavilion/waitingLight';

export const NavigateInTheLight: React.FC<NavigateProps> = (props) => {
  const theme = useWaitingLight(false, true);
  return (
    <>
      <PageLight theme={theme} />
      <RouterNavigate {...props} />
    </>
  );
};

export default NavigateInTheLight;
